import * as B from '@blueprintjs/core';
import React from 'react';

import {NotesActions} from 'app/stores/NotesStore';

interface Props {
  map: mapboxgl.Map;
  notesActions: NotesActions;
}

const MapContextMenu: React.FunctionComponent<Props> = ({map, notesActions}) => {
  const [menu, setMenu] = React.useState<{
    offset: {left: number; top: number};
    lngLat: mapboxgl.LngLat;
  } | null>(null);
  // Mapbox cancels this event itself when a right-drag rotates the map, and
  // right-drag does nothing otherwise, since dragRotate is off unless 3D
  // terrain is on.
  React.useEffect(() => {
    const onContextMenu = (e: mapboxgl.MapMouseEvent) => {
      setMenu({
        offset: {left: e.originalEvent.clientX, top: e.originalEvent.clientY},
        lngLat: e.lngLat,
      });
    };

    map.on('contextmenu', onContextMenu);
    return () => {
      map.off('contextmenu', onContextMenu);
    };
  }, [map]);

  if (!menu) {
    return null;
  }

  const addNoteHere = () => {
    const {lng, lat} = menu.lngLat;
    notesActions.startComposingNote({
      source: 'contextMenu',
      geometry: {type: 'Point', coordinates: [lng, lat]},
      anchor: {lng, lat},
    });
    setMenu(null);
  };

  return (
    <B.ContextMenuPopover
      isOpen
      targetOffset={menu.offset}
      onClose={() => setMenu(null)}
      content={
        <B.Menu>
          <B.MenuItem icon="annotation" text="Add a note here" onClick={addNoteHere} />
        </B.Menu>
      }
    />
  );
};

export default MapContextMenu;
